<template>
  <div class="faq-item">
    <div class="faq-row" @click="showAnswer" v-click-outside="onClickOutside">
      <span class="faq-number">{{ String(index).padStart(2, '0') }}</span>
      <span class="faq-question" v-html="faqLists.question"></span>
      <button class="faq-toggle">{{ isAnswer ? '−' : '+' }}</button>
    </div>
    <div v-if="isAnswer" class="faq-answer">
      <div v-html="faqLists.answer"></div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "click-outside-vue3";
export default {
  name: "faq-list",
  props: {
    faqLists: { type: Object, default: () => ({ question: "", answer: "" }) },
    index: { type: Number, default: 1 },
  },
  data() { return { isAnswer: false }; },
  directives: { clickOutside: vClickOutside.directive },
  methods: {
    onClickOutside() { this.isAnswer = false; },
    showAnswer() { this.isAnswer = !this.isAnswer; },
  },
};
</script>

<style scoped>
.faq-item {
  border-top: 1px dashed #00000080;
  border-left: none;
  border-right: none;
  padding: 0;
}

.faq-item:last-child {
  border-bottom: 1px dashed #00000080;
} /* ← accolade manquante ici */

.faq-row {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px 20px;
  cursor: pointer;
}

.faq-number {
  font-family: 'DM Sans', sans-serif;
  font-size: 0.8rem;
  color: #111827;
  flex-shrink: 0;
  width: 28px;
}

.faq-question {
  flex: 1;
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #111827;
}

.faq-toggle {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #F59E0B;
  flex-shrink: 0;
  padding: 0;
  line-height: 1;
  font-weight: 700;
}

.faq-answer {
  padding: 0 20px 24px 68px;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.875rem;
  color: #4B5563;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .faq-row {
    padding: 20px 12px;
    gap: 16px;
  }

  .faq-number {
    font-size: 0.75rem;
    width: 24px;
  }

  .faq-question {
    font-size: 0.9rem;
  }

  .faq-toggle {
    font-size: 1rem;
  }

  .faq-answer {
    padding: 0 0 20px 36px;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .faq-row {
    padding: 16px 8px;
    gap: 12px;
  }

  .faq-number {
    font-size: 0.7rem;
    width: 20px;
  }

  .faq-question {
    font-size: 0.85rem;
  }

  .faq-toggle {
    font-size: 0.9rem;
  }

  .faq-answer {
    padding: 0 0 16px 28px;
    font-size: 0.75rem;
  }
}
</style>